import PresetsQuery from './PresetsQuery.js';
import ethereum from 'decentralized/ethereum.js';

const presets = ethereum.presets;

class PresetsCache {
    constructor() {
        this.queries = [];
    }

    clear() {
        this.queries = [];
    }

    async getPaginatedPresets(filter, start, size=10, guildId=0) {
        filter = {... filter};
        let query = new PresetsQuery(filter);
        let foundQuery = this.queries.find(
            q => q.isEqual(query));

        if (foundQuery !== undefined) {
            return foundQuery.getPaginatedResults(start, size);
        }

        let results = await presets.getPresets(filter, guildId);
        query.results = results;
        this.queries.push(query);
        return query.getPaginatedResults(start, size);
    }
}

export default PresetsCache;
